import { TIMELINE_CANVAS_ID } from '../constants';

export const getTimelineCanvas = () => {
    const el = document.querySelector(`[data-test-id="${TIMELINE_CANVAS_ID}"]`);
    if (!el) {
        throw new Error(`No ${TIMELINE_CANVAS_ID} element found`);
    }
    return el as HTMLCanvasElement;
};
